import styled from "styled-components"


export const ResponsiveBar = styled.svg`
    display: none;
    width: 30px;
    height: 30px;


    @media screen and (max-width: 950px){
      display:flex;
    }


`
export const Responsive = styled.div`
    display: none;

    @media screen and (max-width: 950px){
  
      display: ${((props) => props.view )};
      flex-direction: column;
      position: absolute;
      top: 0;
      right: 0;
      padding: 5px;
      transform: translate(1%,65%);
      border: 0;
      background-color: #262626;
    
      
    
  }

    @media screen and (max-width: 450px){

        display: ${((props) => props.view )};
        flex-direction: column;
        position: absolute;
        top: 0;
        right: 0;
        padding: 5px;
        transform: translate(1%,70%);
        border: 0;
        background-color: #262626;
      
        
      
    }


`
export const ResponsiveIconContainer = styled.div`    
    display: flex;
    justify-content: center;
    border: 2px #595959 solid;
    stroke-width: 2px;
    border-radius: 50%;
    padding: 5px;
    margin-left: 15px;
    margin-bottom: 5px;
    width: 30px;
    height: 30px;
    cursor: pointer;

    &:hover{
      border-color:#40a9ff;
      color: #40a9ff;
      background-color: rgba(64,169,255,0.3125) ;
    }

    &:hover > div > svg > g > g > path {
      fill: #40a9ff;
    }

    &:hover > svg > path {
      fill:#40a9ff;
    }

`


export const LastResponsiveIconContainer = styled.div`
    display: flex;
    justify-content: center;
    border-radius: 50%;
    padding: 3px;
    margin-left: 10px;
    cursor: pointer;

    &:hover{
    border-color:blue;
  }

`